/**
 * TabEmptyState Component
 * Shared empty state view for tab content areas.
 * Renders a heading, description, optional CTA button,
 * and a carousel of suggested rituals for discovery.
 */

import { Button } from "@components/ui/button"
import { useNavigate } from "react-router-dom"
import { SuggestedRitualsSection } from "./SuggestedRitualsSection"

interface TabEmptyStateProps {
  title: string
  description: string
  ctaLabel?: string
  ctaTo?: string
}

export function TabEmptyState({ title, description, ctaLabel, ctaTo }: TabEmptyStateProps) {
  const navigate = useNavigate()

  return (
    <div className="md:pt-8 px-5 md:px-0">
      <h3 className="text-[18px] font-semibold leading-[30px] uppercase text-text-primary">
        {title}
      </h3>
      <p className="text-sm text-primary opacity-90 mt-2.5 leading-relaxed">{description}</p>
      {ctaLabel && ctaTo && (
        <Button
          variant="outline"
          className="mt-5 h-[50px] w-full md:w-[280px] rounded-full text-[14px] font-semibold uppercase cursor-pointer"
          onClick={() => navigate(ctaTo)}
        >
          {ctaLabel}
        </Button>
      )}

      <SuggestedRitualsSection />
    </div>
  )
}
